import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { NOWCAST_SOURCES } from '../nowcast-map/nowcast-map-constants';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { DataService } from 'src/app/main/shared/services/data.service';

@Component({
  selector: 'app-nowcast-sidebar',
  templateUrl: './nowcast-sidebar.component.html',
  styleUrls: ['./nowcast-sidebar.component.scss']
})
export class NowcastSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: any;
  @Output() playPos = new EventEmitter<any>();

  isInitialLoad: boolean = false;
  queryParams: any = {};
  selected: string;
  activeRadioList: boolean[] = [];
  dateIndexLength: any;
  sourceOptions: any;
  selectedSource: any;
  destroy: any = new Subject()
  subscriptions: any = [];
  sessionStorage: any = {
    params: {}
  };

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router, private gisMapComp: GisDimsMapComponent, private dataService: DataService) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
  }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents()
    this.setParams()
  }

  subscribeEvents() {
    const selectedParamsRef = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.gisUtils.setSelectedParams(this.queryParams);
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.dateIndexLength = this.queryParams['source'] != 'EUMETSAT' ? 12 : 16
        this.sourceOptions = NOWCAST_SOURCES['sourceList']
        this.selectedSource = this.queryParams['source']
      }
    });
    this.subscriptions.push(selectedParamsRef)
  }


  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }
    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  buttonClicked(blockNumber: any, from?: string) {
    // console.log("blockNum", this.blockNum);
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
      localStorage.setItem("playBarIndex", blockNumber)
    }
    // labelStrings is briefly empty while a source switch loads its time list
    if (this.labelStrings && this.labelStrings[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i: any) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['label']['label'];
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'NOWCAST';
    // currentUrlParams['source'] = 'RADAR+CTT'
    currentUrlParams['source'] = 'IMD RADAR'
    if (this.isInitialLoad) {
      let metaInfo: any = localStorage.getItem('metaInfo');
      let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
      let finalMetaInfo = metaInfoJson;
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(finalMetaInfo.userDetailsJson.data.location, finalMetaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1]
      currentUrlParams['locName'] = currentLocations[0]
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      this.isInitialLoad = false
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  navigateToSeamlessView(event: Event) {
    event.preventDefault();
    this.router.navigate(['/nowcastweather/seamlessview']);
  }

  sourceChange() {
    let options = { ...this.queryParams }
    options['source'] = this.selectedSource
    this.gisMapComp.isRadarToggleActive = false
    if (this.selectedSource != 'CUSTOM') {
      this.gisUtils.setSelectedParams(options)
    } else {
      this.router.navigate(['', 'nowcastweather', 'radar-forecast', 'akbm'])
    }
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    })
  }

}
